export default function ProcessDetail() {
  return (
    <section className="py-24 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#6B4E9C]/10 text-[#6B4E9C] px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap mb-6">
            세 번째 기준
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            타협 없는 공정
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            최고의 품질은 섬세한 과정에서 완성됩니다.<br />
            세척과 선별과 착즙을 핵심 공정으로 관리합니다.
          </p>
        </div>

        <div className="space-y-12 mt-16">
          {/* 1. 청정 암반수 세척 */}
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#6B4E9C] text-white rounded-full font-bold text-xl">
                    1
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">청정 암반수 세척</h3>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  맛의 기본을 만드는 첫 단계는 청정 암반수 세척입니다.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  착즙 전, 청정 암반수로 포도를 철저히 세척합니다. 이 과정은 불필요한 이물 걱정을 줄입니다. 포도즙의 깔끔한 맛을 만드는 중요한 기본입니다.
                </p>
              </div>
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0161fc2ac9625ad0911c4a2fc906f55f.jpg"
                  alt="청정 암반수 세척"
                  className="w-full h-auto rounded-xl shadow-md"
                />
              </div>
            </div>
          </div>

          {/* 2. 고당도 포도 선별 */}
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="relative order-2 lg:order-1">
                <img 
                  src="https://readdy.ai/api/search-image?query=Premium%20quality%20purple%20grapes%20being%20carefully%20selected%20and%20sorted%20by%20hand%2C%20showing%20only%20the%20best%20ripest%20grapes%20with%20perfect%20color%20and%20size%2C%20professional%20food%20processing%20environment%2C%20natural%20lighting%20highlighting%20grape%20quality%20and%20sweetness%2C%20detailed%20close-up%20showing%20selection%20process%2C%20ultra%20sharp%20details%2C%20emphasis%20on%20quality%20control&width=800&height=600&seq=selection-process-001&orientation=landscape"
                  alt="고당도 포도 선별"
                  className="w-full h-auto rounded-xl shadow-md"
                />
              </div>
              <div className="space-y-6 order-1 lg:order-2">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#6B4E9C] text-white rounded-full font-bold text-xl">
                    2
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">고당도 포도 선별</h3>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  최고의 맛은 최고의 원료에서 나옵니다.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  당도가 우수한 포도만 선별합니다. 엄격한 기준으로 맛의 중심이 되는 원료를 고릅니다. 인위적인 단맛이 아니라 원료 자체의 달콤함을 지킵니다.
                </p>
              </div>
            </div>
          </div>

          {/* 3. 고성능 착즙 */}
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#6B4E9C] text-white rounded-full font-bold text-xl">
                    3
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">고성능 착즙</h3>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  고성능 착즙기로 맛과 향을 온전히 보존합니다.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  포도 과육이 가진 섬세한 풍미를 최대한 살립니다. 동시에 마시기 편안한 부드러운 질감을 구현합니다. 기술은 자연의 가치를 높이는 데 사용됩니다.
                </p>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20high-performance%20cold%20press%20juicing%20equipment%20processing%20purple%20grapes%2C%20professional%20stainless%20steel%20machinery%20in%20clean%20facility%2C%20showing%20gentle%20extraction%20process%20preserving%20natural%20flavors%2C%20technical%20food%20processing%20photography%2C%20bright%20lighting%20emphasizing%20precision%20and%20quality%2C%20ultra%20sharp%20details%2C%20industrial%20food%20safety%20standards&width=800&height=600&seq=juicing-equipment-001&orientation=landscape"
                  alt="고성능 착즙"
                  className="w-full h-auto rounded-xl shadow-md"
                />
              </div>
            </div>
          </div>

          {/* 4. 저온 착즙 */}
          <div className="bg-gradient-to-br from-[#6B4E9C]/5 to-purple-50 rounded-2xl p-8 lg:p-12 border-2 border-[#6B4E9C]/20">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="relative order-2 lg:order-1">
                <img 
                  src="https://readdy.ai/api/search-image?query=Cold-pressed%20grape%20juice%20extraction%20process%20showing%20temperature-controlled%20environment%2C%20fresh%20purple%20grapes%20being%20gently%20pressed%20without%20heat%2C%20professional%20food%20processing%20facility%20with%20modern%20equipment%2C%20emphasis%20on%20preserving%20natural%20flavors%20and%20nutrients%2C%20technical%20photography%20showing%20cold%20press%20technology%2C%20ultra%20sharp%20details%2C%20clean%20industrial%20setting&width=800&height=600&seq=cold-press-001&orientation=landscape"
                  alt="저온 착즙"
                  className="w-full h-auto rounded-xl shadow-md"
                />
              </div>
              <div className="space-y-6 order-1 lg:order-2">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#6B4E9C] text-white rounded-full font-bold text-xl">
                    4
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">저온 착즙 원칙</h3>
                </div>
                <p className="text-lg font-semibold text-[#6B4E9C] leading-relaxed">
                  맛을 지키는 가장 중요한 원칙은 열을 가하지 않는 것입니다.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  저온 착즙은 포도 특유의 생생한 향과 신선한 풍미를 보존합니다. 가열 방식은 열처리 과정에서 향이 달라질 수 있습니다.
                </p>
                <p className="text-gray-900 font-semibold">
                  그래서 저희는 맛의 결을 지키는 공정을 선택합니다.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <p className="text-lg text-gray-700 leading-relaxed">
            원료의 가치를 온전히 지키기 위한 선택입니다.
          </p>
        </div>
      </div>
    </section>
  );
}
